import { media } from 'helpers/mediaQueryStyle'
import styled, { css } from 'styled-components'
import { temporaryTheme } from 'styles/theme'

interface ButtonActionProps {
  color: string
}

interface WrapperProps {
  status: string
}

const WrapperModifier = {
  canceled: () => css`
    ${DateInfo} {
      color: ${temporaryTheme.colors.red};
    }
    ${AppointmentInfo} {
      color: ${temporaryTheme.colors.red};
    }
  `
}

export const Wrapper = styled.main<WrapperProps>`
  ${({ status }) => css`
    width: 100%;
    background: #ffffff;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    padding: 16px;
    margin-bottom: 12px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);

    ${status === 'canceled' && WrapperModifier.canceled()};

    ${media.mobile`
      padding: 12px;
    `}
  `}
`

export const CardContent = styled.div`
  display: flex;
  align-items: center;
  gap: 1.5rem;
  width: 100%;

  ${media.mobile`
    flex-direction: column;
    align-items: flex-start;
    gap: 1rem;
  `}
`
export const InfoBox = styled.main`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  flex-shrink: 0;

  svg {
    color: #433f3e;
    width: 24px;
    height: 24px;
    flex-shrink: 0;
  }

  &.info {
    min-width: 200px;
  }
`

export const IconBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`

export const Name = styled.p`
  font-weight: 600;
  font-size: 14px;
  font-family: 'Poppins', sans-serif;
  color: #433f3e;
  margin: 0;
  line-height: 140%;
`

export const DateInfo = styled.div`
  font-family: 'Poppins', sans-serif;
  font-weight: 400;
  font-size: 14px;
  color: #433f3e;
  flex: 1;
  min-width: 150px;

  ${media.mobile`
    min-width: 100%;
  `}
`

export const AppointmentInfo = styled.div`
  font-family: 'Poppins', sans-serif;
  font-weight: 400;
  font-size: 14px;
  color: #433f3e;
  flex: 1;
  min-width: 150px;
  white-space: nowrap;

  ${media.mobile`
    min-width: 100%;
    white-space: normal;
  `}
`

export const ButtonActions = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  flex-shrink: 0;

  .box_link {
    display: flex;
    align-items: center;
    gap: 0.75rem;
  }

  ${media.mobile`
    width: 100%;
    justify-content: flex-start;
    margin-top: 0.5rem;
  `}
`

export const Button = styled.button<ButtonActionProps>`
  ${({ color }) => css`
    all: unset;
    height: 30px;
    width: 153px;
    background: ${color};
    border-radius: 4px;
    text-align: center;
    color: white;
    font-family: 'Nunito';
    font-size: 12px;
    font-weight: 600;
    cursor: pointer;
    opacity: 0.85;

    &:hover {
      opacity: 1;
    }

    ${media.mobile`
      width: 100%;
      max-width: 250px;
    `}
  `}
`

export const ButtonLink = styled.button`
  all: unset;
  font-family: 'Poppins', sans-serif !important;
  font-size: 14px;
  font-weight: 400;
  color: #433f3e;
  cursor: pointer;
  padding: 6px 12px;
  border: 1px solid #cccccc;
  border-radius: 4px;
  background: transparent;
  white-space: nowrap;
  transition: all 0.2s;
  text-transform: lowercase;

  &:hover {
    background: #f5f5f5;
    border-color: #999999;
  }
`

export const ButtonLinkNoBorder = styled.button`
  all: unset;
  font-family: 'Poppins', sans-serif !important;
  font-size: 14px;
  font-weight: 400;
  color: #433f3e;
  cursor: pointer;
  padding: 6px 12px;
  border: none;
  border-radius: 4px;
  background: transparent;
  white-space: nowrap;
  transition: all 0.2s;

  &:hover {
    background: #f5f5f5;
  }
`
